/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./app-root-styler.scss.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./app-root-styler";
import * as i3 from "../auth.service";
var styles_AppRootStylerComponent = [i0.styles];
var RenderType_AppRootStylerComponent = i1.ɵcrt({ encapsulation: 2, styles: styles_AppRootStylerComponent, data: {} });
export { RenderType_AppRootStylerComponent as RenderType_AppRootStylerComponent };
export function View_AppRootStylerComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
export function View_AppRootStylerComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-root-styler", [], null, null, null, View_AppRootStylerComponent_0, RenderType_AppRootStylerComponent)), i1.ɵdid(1, 49152, null, 0, i2.AppRootStylerComponent, [i3.AuthService], null, null)], null, null); }
var AppRootStylerComponentNgFactory = i1.ɵccf("app-root-styler", i2.AppRootStylerComponent, View_AppRootStylerComponent_Host_0, {}, {}, []);
export { AppRootStylerComponentNgFactory as AppRootStylerComponentNgFactory };
